module.exports = __webpack_public_path__ + "media/application/images/ukas_certification-5bc0f89e379195a33518a50f36a9e29e.jpg";